/**
 * Import constants
 */
import { GET_USERS_DATA, GET_USERS_DATA_PENDING, GET_USERS_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: [],
	error: null
};

/**
 * Users reducers
 * @param {*} state
 * @param {*} action
 */
export const usersReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_USERS_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_USERS_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_USERS_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
